// extracted by css-extract-rspack-plugin
export default {"grid":"GridSection-module__grid__XHuWCmz"};